import dp from '../assets/dp.png';
import edit from '../assets/edit.png';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { url } from '../utils/config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import loaderStateAtom from '../atoms/loaderStateAtom';
import backButton from "../assets/backButton.png";
import { btnOne, containerOne, inputStyleTwo, label, title,profileInputStyle } from '../utils/style';
import myInfoAtom from '../atoms/myInfoAtom';
import navHeaderAtom from '../atoms/navHeaderAtom';
import textValidator from '../helper_functions/textValidator';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/high-res.css';
import "./sliderCalendar.css";


function ProfileSetting() {
    const [profileData, setProfileData] = useState({});
    const [updatedData, setUpdatedData] = useState({});
    const [profileImage, setProfileImage] = useState(null);
    const [profileImageUrl, setProfileImageUrl] = useState(null);
    const [showSaveButton, setShowSaveButton] = useState(false);
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom);
    const [header, setHeader] = useRecoilState(navHeaderAtom);
    const [myInfo] = useRecoilState(myInfoAtom);
    const [fetchedProfileDate,setFetchedProfileData] = useState({});

    let navigate = useNavigate();

    useEffect(() => {
        setHeader('My Profile');
        fetchProfileData();
    }, []);

    // console.log(myInfo);
    function updateProfile(e) {
        const { name, value } = e.target;

        if (name === "firstName") {
            const words = value.trim().split(/\s+/);
            if (words.length > 2) {
                toast.error("First Name can contain only two words!", { autoClose: 3000 });
                return;
            }
        }

        if (name === "lastName" && value.includes(" ")) {
            toast.error("Last Name cannot contain spaces!", { autoClose: 3000 });
            return;
        }

        setShowSaveButton(true);
        setUpdatedData(prev => ({ ...prev, [name]: value }));
        setProfileData(prev => ({ ...prev, [name]: value }));
    }

    function selectImage(e) {
        const file = e.target.files[0];
        if (!file) return;

        setProfileImage(file);
        setProfileImageUrl(URL.createObjectURL(file));
        setShowSaveButton(true);
    }

    async function fetchProfileData() {
        try {
            setShowLoader(true);
            const { data } = await axios.get(`${url}/profile`, {
                headers: { authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setProfileData(data.data);
            setProfileImageUrl(data.data.profileImage || dp);
            setFetchedProfileData(data.data);
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to fetch profile data", { autoClose: 3000 });
        } finally {
            setShowLoader(false);
        }
    }

    console.log(profileData);

    function isValidPhoneNumber(phoneNumber) {
        // Remove country code and check for length (10-15 digits is reasonable for international numbers)
        const rawPhone = phoneNumber.replace(/\D/g, ""); // Remove non-numeric characters
        return rawPhone.length >= 10 && rawPhone.length <= 15;
    }

    async function updateProfileData() {
        if (!textValidator(profileData.firstName, true)) {
            return toast.error('First Name can contain only letters and up to two words!', { autoClose: 3000 });
        }
        if (!textValidator(profileData.lastName)) {
            return toast.error('Last Name must be a single word with only letters!', { autoClose: 3000 });
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(profileData.email)) {
            return toast.error('Please enter a valid email address', { autoClose: 3000 });
        }

        // Check if phone number is valid
        if (!isValidPhoneNumber(profileData.phone)) {
            return toast.error('Please enter a valid phone number (10-15 digits)', { autoClose: 3000 });
        }

        setShowLoader(true);
        try {
            const token = localStorage.getItem('token');
            const headers = { authorization: `Bearer ${token}` };

            if (profileImage) {
                const formData = new FormData();
                formData.append('image', profileImage);
                await axios.patch(`${url}/profile_image`, formData, { headers });
                toast.success("Profile image updated!", { autoClose: 3000 });
            }

            if (Object.keys(updatedData).length > 0) {
                await axios.patch(`${url}/profile`, updatedData, { headers });
                toast.success("Profile updated successfully!", { autoClose: 3000 });
            }

            await fetchProfileData();
            setShowSaveButton(false);
        } catch (err) {
            toast.error(err.response?.data?.message || "Profile update failed", { autoClose: 3000 });
        } finally {
            setShowLoader(false);
        }
    }

    return (
        <div className={containerOne}>
            <div className="flex flex-col justify-center gap-2 items-center py-2">
                <div className='rounded-full'>
                    <img 
                        src={dp} 
                        width={100} 
                        height={100} 
                        alt="Profile"
                        className="rounded-full"
                    />
                </div>
                <input 
                    type="file" 
                    accept="image/*" 
                    onChange={selectImage} 
                    className="hidden" 
                    id="profilePicUpload"
                />
                <label htmlFor="profilePicUpload" className="cursor-pointer">
                    <img src={edit} width={20} height={20} alt="Edit" />
                </label>
                <div className={title}>{`${fetchedProfileDate?.firstName} ${fetchedProfileDate?.lastName}`}</div>
                <div>Hello, I am {`${fetchedProfileDate?.firstName} ${fetchedProfileDate?.lastName}`}</div>
            </div>
            <div>
                <label className={label}>First Name</label>
                <input className={profileInputStyle} name='firstName' value={profileData.firstName || ''} onChange={updateProfile} />

                <label className={label}>Last Name</label>
                <input className={profileInputStyle} name='lastName' value={profileData.lastName || ''} onChange={updateProfile} />

                <label className={label}>Email</label>
                <input className={inputStyleTwo} type="email" name='email' value={profileData.email || ''} onChange={updateProfile} />

                <label className={label}>Phone</label>
                <PhoneInput
                    inputStyle={{ width: 'inherit' }}
                    inputProps={{ name: 'phone', required: true }}
                    value={profileData.phone || ''}
                    onChange={(value) => {
                        setProfileData(prev => ({ ...prev, phone: value }));
                        setUpdatedData(prev => ({ ...prev, phone: value }));
                        setShowSaveButton(true);
                    }}
                    country={'us'} 
                    preserveOrder={['us', 'ca']}
                    preferredCountries={['us', 'ca']}
                />
            </div>
            {showSaveButton && (
                <div className='py-3'>
                    <button className={btnOne} onClick={updateProfileData}>Update</button>
                </div>
            )}
        </div>
    );
}

export default ProfileSetting;
